import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { PolicyUserGroup, UserGroup, UserGroupMember, UserGroupPolicy } from '../../types/GroupTypes'

export interface GroupState {
  userGroups: UserGroup[] | undefined
  policyUserGroups: PolicyUserGroup[] | undefined
  userGroup: UserGroup | undefined
  userGroupMembers: UserGroupMember[] | undefined
  userGroupPolicies: UserGroupPolicy[] | undefined
  totalPagesMemberGroups: number
  totalPagesPolicyGroups: number
  currentPageMemberGroups: number
  currentPagePolicyGroups: number
  allPoliciesForOrg: UserGroupPolicy[] | undefined
}

const initialState: GroupState = {
  userGroups: undefined,
  policyUserGroups: undefined,
  userGroup: undefined,
  userGroupMembers: undefined,
  userGroupPolicies: undefined,
  totalPagesMemberGroups: 0,
  totalPagesPolicyGroups: 0,
  currentPageMemberGroups: 0,
  currentPagePolicyGroups: 0,
  allPoliciesForOrg: undefined,
}

export const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    setUserGroups(state, action: PayloadAction<UserGroup[] | undefined>) {
      state.userGroups = action.payload
    },
    setPolicyUserGroups(state, action: PayloadAction<PolicyUserGroup[] | undefined>) {
      state.policyUserGroups = action.payload
    },
    setUserGroup(state, action: PayloadAction<UserGroup | undefined>) {
      state.userGroup = action.payload
    },
    setUserGroupMembers(state, action: PayloadAction<UserGroupMember[] | undefined>) {
      state.userGroupMembers = action.payload
    },
    setUserGroupPolicies(state, action: PayloadAction<UserGroupPolicy[] | undefined>) {
      state.userGroupPolicies = action.payload
    },
    setTotalPagesMemberGroups(state, action: PayloadAction<number>) {
      state.totalPagesMemberGroups = action.payload
    },
    setTotalPagesPolicyGroups(state, action: PayloadAction<number>) {
      state.totalPagesPolicyGroups = action.payload
    },
    setCurrentPageMemberGroups(state, action: PayloadAction<number>) {
      state.currentPageMemberGroups = action.payload
    },
    setCurrentPagePolicyGroups(state, action: PayloadAction<number>) {
      state.currentPagePolicyGroups = action.payload
    },
    setAllPoliciesForOrg(state, action: PayloadAction<UserGroupPolicy[] | undefined>) {
      state.allPoliciesForOrg = action.payload
    },
  },
})
export const selectGroup = (state: RootState) => state.groups

export const {
  setUserGroups,
  setPolicyUserGroups,
  setUserGroup,
  setUserGroupMembers,
  setUserGroupPolicies,
  setTotalPagesMemberGroups,
  setTotalPagesPolicyGroups,
  setCurrentPageMemberGroups,
  setCurrentPagePolicyGroups,
  setAllPoliciesForOrg,
} = groupSlice.actions
export default groupSlice.reducer
